import { z } from 'zod';

export const glowUpProductSchema = z.object({
  categoryId: z.coerce.number().int().positive('La catégorie est requise'),
  title: z.string().trim().min(1, 'Champ requis'),
  description: z.string().trim().optional(),
  link: z
    .string()
    .trim()
    .min(1, 'Champ requis')
    .regex(/^https?:\/\//, 'Le lien doit commencer par http:// ou https://'),
  ctaText: z.string().trim().min(1, 'Champ requis'),
  position: z.coerce.number().int().min(0).optional(),
  active: z.boolean().optional(),
  file: z.instanceof(File),
});

export const updateGlowUpProductSchema = glowUpProductSchema.extend({
  file: z.instanceof(File).optional(),
});

export type GlowUpProductSchemaType = z.infer<typeof glowUpProductSchema>;
export type UpdateGlowUpProductSchemaType = z.infer<
  typeof updateGlowUpProductSchema
>;
